import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import { Context } from "./Utils/Store";
import axios from "axios";
import { getAppSettings } from "./Utils/AppSettings"
import Button from '@mui/material/Button';
import './css/App.css';

function Main() {

  const history = useHistory();
  const [, setStore] = useContext(Context);
  const [loginName, setLoginName] = useState("");
  const [loginId, setLoginId] = useState("");
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState("");
  const [version, setVersion] = useState("");
  const settings = getAppSettings();

  const handleClick = () => {
    if (loginName !== '' && loginId !== "") {
      setLoading(true);
      axios.post(settings.apiUrl + '/driver/authenticate', { DriverName: loginName, DriverId: loginId }).then(response => {
        setLoading(false);
        if (response.status === 200) {
          if (response.data.Locked) {
            setResult("Account Locked");
          } else {
            setStore({ type: "DRIVER", payload: response.data });
            history.push({
              pathname: "home"
            });
          }
        }
      }).catch(error => {
        setLoading(false);
        setResult("Login Error");
        console.log(error);
      });
    } else {
      setResult("Name and ID Required");
    }
  }

  useEffect(() => {
    if (loading) {
      setLoading(false);
      setVersion(settings.appVersion);
    }
  }, [loading, settings]);

  return (
    <div className="page">
      <div className="spacer10x20" />
      <div className='logo' />
      <div>
        <h2>Driver Trip Log</h2>
      </div>
      <div className='hbox'>
        <div>
          <div className='labelMain'>Driver:</div>
          <div className='labelMain'>ID:</div>
        </div>
        <div className='spacer10x40' />
        <div>
          <div><input className='inputMain' value={loginName} onChange={(e) => { setLoginName(e.target.value) }} /></div>
          <div><input className='inputMain inputid' type="tel" value={loginId} onChange={(e) => { setLoginId(e.target.value) }} /></div>
        </div>
      </div>
      <div className='spacer10x40' />
      <div>
        <Button variant='contained' onClick={handleClick}>LOGIN</Button>
      </div>
      <div className='spacer10x40' />
      <div className="loginmsg">{result}
        <div className="spacer10x20" />
        {/* <Spinner hidden={!loading} /> */}
        <div hidden={!loading}>Loading...</div>
      </div>
      <div className='hbox'>
        <div className='swLogo'></div>
        <div className='swBanner'></div>
      </div>
      <div className='version'>Version {version}</div>
      <p> </p>
    </div>
  );
}

export default Main;
